import * as React from 'react';
const SvgBookmark = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M16 4.5v14.11l-2.5-2.45c-.4-.4-.94-.63-1.5-.63s-1.1.23-1.5.63L8 18.61V4.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5M15.48 2H8.52c-.84 0-1.47.21-1.89.64S6 3.7 6 4.54v16.38c0 .34.08.61.25.8s.4.28.69.28c.21 0 .42-.07.61-.22.19-.14.49-.41.89-.8l3.48-3.41s.05-.04.08-.04.05.01.08.04l3.48 3.41c.4.38.7.65.89.8s.39.22.61.22c.3 0 .53-.09.69-.28.17-.19.25-.45.25-.8V4.54c0-.84-.21-1.48-.63-1.9-.42-.43-1.05-.64-1.89-.64"
    />
  </svg>
);
export default SvgBookmark;
